import { Component, Story, Knobs } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  selectedColour: { default: '#BADA55', editor: 'textbox' },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A custom colour picker',
  coreComponent_v3: {
    html: `<tag3-custom-colour-picker{{...knobs}}></tag3-custom-colour-picker>`,
    knobs: PlaygroundStoryKnobs,
  },

  reactWrapper_v3: {
    jsx: `<Tag3CustomColourPicker{{...knobs}}/>`,
    knobs: PlaygroundStoryKnobs,
  },
};

export const TagCustomColourPickerDocs: Component = {
  type: 'component',
  name: 'custom-colour-picker',
  description: 'Renders a custom colour picker',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'selectedColour',
      description: 'The selected colour value',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'selectedColourChange',
      description: 'Raised when the selected colour is changed',
      parameters: [{ name: 'value', description: 'The colour value', type: 'string' }],
    },
  ],
  methods: [],
  stories: [PlaygroundStory],
};
